export default {
  locale: 'en',
  HomePageHeroText: 'Go Beyond MDM with Esper’s Android DevOps Platform',
  HomePageHeroDescription:
    'The Industry’s Most Powerful Cloud Tools for Android Device Deployment and Application Management.',
  HomePageHeroCTA: 'Get Started',
  HomePageHeroSubText1:
    'Esper is the first DevOps platform for an agile approach to the Android device lifecycle.',
  HomePageHeroSubText2:
    'Customers worldwide use Esper’s cloud management tools for Android device deployment, app development, and monitoring.',
  HomePageDevopsSectionTitle: 'Esper for Android DevOps',
  HomePageDevopsSectionDescription:
    'Android DevOps is the practice of delivering exceptional customer experiences with a toolchain for collaboration, visibility, and control throughout the device lifecycle. Esper’s platform helps you respond in real-time to device state changes - including the health and performance of apps, configurations, OS, firmware, and more.',
  HomePageDevopsDevToolsTitle: 'Dev Tools',
  HomePageDevopsDevToolsDescription:
    'Build, deploy, and debug with developer tools and custom OS - Esper Enhanced Android. Esper’s APIs, SDKs, CLI, and IDE plugin streamline custom apps and cloud integrations.',
  HomePageDevopsPipelineTitle: 'Advanced DevOps Pipelines',
  HomePageDevopsPipelineDescription:
    'Create global pipelines to continuously improve fleet productivity and performance. Automate deployment rollouts by pipeline stage, device group, or success criteria.',
  HomePageDevopsDeviceTelemetryTitle: 'Device Telemetry',
  HomePageDevopsDeviceTelemetryDescription:
    'Improve rollouts and debugging with telemetry data to understand OS, system, and app health - including battery, network, data usage, and storage for supported devices.',
  HomePageFutureOfMDMTitle: 'Esper is the Future of Android MDM',
  HomePageFutureOfMDMDesc1:
    'Traditional MDM solutions aren’t designed to lock devices to kiosk mode or support other non-traditional Android use cases.',
  HomePageFutureOfMDMDesc2:
    'Esper helps you take control of the Android lifecycle, even when you’re deploying a mix of traditional smartphones, tablets and IoT devices.',
  HomePageAndroidManagementFeaturesTitle:
    'Esper’s Essential Android Management Features',
  HomePageAppManagementTitle: 'App Management',
  HomePageAppManagementDesc:
    'Private Apps, Google Play Apps, Schedule App Updates',
  HomePageDeviceManagementTitle: 'Device Management',
  HomePageDeviceManagementDesc:
    'Device Actions, Event Feeds, Device Information',
  HomePageDeviceGroupTItle: 'Device Groups',
  HomePageDeviceGroupDesc: 'Group Commands, Group App Installs',
  HomePageGMSAOSPTitle: 'GMS & AOSP',
  HomePageGMSAOSPDesc: 'GMS-Certified Support, AOSP Support',
  HomePageKioskModeTitle: 'Kiosk Mode',
  HomePageKioskModeDesc: 'Granular Lock Down',
  HomePageReportsTitle: 'Reports',
  HomePageReportsDesc: 'Custom Reports, Device Graphs',
  HomePageAlertsTitle: 'Alerts',
  HomePageAlertsDesc: 'Custom Alerts, Rich Alerts Engine',
  HomePageGeofencingTitle: 'Geofencing',
  HomePageGeofencingDesc: 'Auto-Lock Lost or Stolen Devices',
  HomePageAdvancedAndroidManagementFeaturesTitle1:
    'Esper’s Advanced Android Management',
  HomePageAdvancedAndroidManagementFeaturesTitle2: 'Features',
  HomePageOTATitle: 'Managed Android OTA Updates',
  HomePageNoTouchProvisioningTitle: 'Seamless, No-Touch Provisioning',
  HomePageRemoteViewTitle: 'Remote View',
  HomePageRemoteControlTitle: 'Remote Control',
  HomePageHardwareSupportTitle: 'Hardware Qualification Support',
  HomePageCustomPriceCTA: 'Request Your Custom Price Quote',
  HomePageEsperVsMDMTitle: 'Esper vs. Traditional MDM',
  HomePageEsperVsMDMDesc1:
    'Esper was created to provide a seamless approach to the entire single-purpose device lifecycle with a rich set of features for Android deployments like kiosks, mPoS, mobile, tablets, and other devices.',
  HomePageEsperVsMDMDesc2:
    'Our cloud platform can seamlessly scale with your product roadmap, allowing you to take advantage of new capabilities as you transform your deployments.',
  HomePageEsperVsMDMFeatures: 'FEATURES',
  HomePageEsperVsMDMFeaturesDeviceManagement: 'Device Management Features',
  HomePageEsperVsMDMFeaturesCompatible: 'Compatible with 99% of Android builds',
  HomePageEsperVsMDMFeaturesCompatibleTraditionalMDM: 'Partial Support',
  HomePageEsperVsMDMFeaturesKioskMode: 'Secure Kiosk Mode',
  HomePageEsperVsMDMFeaturesPipelines:
    'CI/CD Automated Pipelines for App & Configuration Deployment',
  HomePageEsperVsMDMFeaturesCustomDevice: 'Custom Device Emulators',
  HomePageEsperVsMDMFeaturesVirtual: 'Virtual Device Lab',
  HomePageEsperVsMDMFeaturesRemoteDebug: 'Secure Remote Debugging',
  HomePageEsperVsMDMFeaturesOSEnhancement:
    'Android OS Enhancement & Managed OTA Updates',
  HomePageEsperVsMDMFeaturesHardwareVendors:
    'Over 35 Validated Hardware Vendors',
  HomePageEsperVsMDMFeaturesCustomAndroid:
    'Custom Android Device Development using MediaTek’s IoT platform',
  HomePageHowCustomersUseEsperTitle: 'How Customers Use Esper',
  HomePageHowCustomersUseEsperDesc1:
    'Esper is deployed on 50,000+ devices worldwide.',
  HomePageHowCustomersUseEsperEd: 'Education',
  HomePageHowCustomersUseEsperRetail: 'Retail',
  HomePageHowCustomersUseEsperResto: 'Restaurants',
  HomePageHowCustomersUseEsperTransportation: 'Transportation & Logistics',
  HomePageHowCustomersUseEsperHospitality: 'Hospitality',
  HomePageHowCustomersUseEsperHealthcare: 'Healthcare',
  HomePageHowCustomersUseEsperDesc21:
    'Across industries, customers rely on our powerful cloud platform',
  HomePageHowCustomersUseEsperDesc22:
    'to go beyond MDM and achieve business transformation.',
  HomePageHowCustomersUseSpireHealthTitle: 'Healthcare',
  HomePageHowCustomersUseSpireHealthDesc:
    'Spire Health uses Esper’s cloud to deploy and manage clinical-grade patient monitoring devices.',

  HomePageHowCustomersUseInSpireHealthTitle: 'Health and Fitness',
  HomePageHowCustomersUseInSpireHealthDesc:
    'Inspire Fitness works with Esper to design and manage its connected fitness products to ensure a seamless customer experience.',
  HomePageHowCustomersUseBoblyTitle: 'Retail',
  HomePageHowCustomersUseBoblyDesc:
    'Bobly partners with Esper to power up sales, transaction and feedback for some of the world’s best known CPG brands.',
  HomePageAndroidDeviceTitle1: 'The First Intelligent Cloud Solution for',
  HomePageAndroidDeviceTitle2: 'Android',
  HomePageAndroidDeviceTitle3: 'Devices',
  HomePageAndroidDeviceDesc:
    'Esper is the first DevOps platform designed for single-purpose Android devices',
  HomePageAndroidDeviceKiosk: 'Kiosks',
  HomePageAndroidDeviceRugged: 'Rugged',
  HomePageAndroidDevicePos: 'POS',
  HomePageAndroidDeviceSmartphone: 'Smartphones',
  HomePageAndroidDeviceTablet: 'Tablets',
  HomePageAndroidDeviceHealth: 'Telehealth',
  HomePageAndroidDeviceFitness: 'Smart Fitness',
  HomePageAndroidDeviceELD: 'ELDs',
  HomePageAndroidDeviceStudent: 'Student Devices',
  HomePageAndroidDeviceSignage: 'Digital Signage',
  HomePageAndroidCompatibilityTitle:
    'We’re compatible with virtually ALL Android hardware and versions 4.4+, so you can deploy and manage your fleet of GMS-certified and AOSP devices.',
  HomePageAndroidCompatibilitySupportAOSP: 'Support for AOSP Devices',
  HomePageAndroidCompatibilityGMSnonGMS: 'GMS-Certified AND Non-GMS Devices',
  HomePageAndroidCompatibilityDeviceSupport: 'Non-Traditional Device Support',
  HomePageAndroidCompatibilityAndroidIOT: 'Deploy and Maintain Android IoT',
  HomePageAndroidCompatibilityAllAndroid: 'Almost ALL Android Welcome',
  HomePageAndroidCompatibilityAndroidVersion: 'Android Versions 4.4+ and 5.x+',
  HomePageAndroidCompatibilityStreamlined: 'Streamlined Deployment',
  HomePageAndroidCompatibilityProvisioning: 'Simple Provisioning & Deployment',
  HomePageAndroidCompatibilityCTA: 'Request a Demo',
  HomePagePricingTitle: 'FREE to Sign Up with Esper',
  HomePagePricingDesc:
    'Esper’s cloud platform for Android MDM is offered at a transparent, unbeatable price point which is backed by industry-leading options for customer support.',
  HomePagePricingStarter: 'Esper Starter',
  HomePagePricingStarterFor: 'For Developers and Startups',
  HomePagePricingStarterFree: 'FREE',
  HomePagePricingStarter100Devices: '100 Devices',
  HomePagePricingEssentials: 'Esper Essentials',
  HomePagePricingEssentialsFor: 'For Smaller Fleets',
  HomePagePricingBilledAnnually: 'Billed Annually',
  HomePagePricingPro: 'Esper Pro',
  HomePagePricingProFor: 'For Large Deployments',
  HomePagePricingProMin1000Devices: 'Minimum 1,000 Devices',
  HomePagePricingOnSiteDeployment:
    'Pricing for on-site deployment support and other premium services is available on request.',
  HomePagePricingCTA: 'Get more info on pricing',
  HomePageSupportedDeviceAsterix: 'For supported devices',
  HomePageOurPartners: 'Our Partners',

  PricingPageHeroText: 'Esper’s Platform Pricing for Android Devices',
  PricingPageFree: 'FREE Forever',
  PricingPageStarter: 'ESPER STARTER',
  PricingPageStartrerFor: 'For Developers and Startups',
  PricingPageStarter100Devices: '100 Devices',
  PricingPageStarterNoCreditCard: 'No credit card required',
  PricingPageStarterLicense: '1 Esper User License',
  PricingPageStarterStorage: '25 MB Application Storage',
  PricingPageStarterSupport: 'Support via Forums',
  PricingPageEssentials: 'ESPER ESSENTIALS',
  PricingPageEssentialsFor: 'For Smaller Fleets',
  PricingPageEssentialsMin100Devices: 'Minimum 100 Devices ',
  PricingPageEssentialsLicense: '5 Esper User License',
  PricingPageEssentialsStorage: '25 MB Application Storage',
  PricingPageEssentialsEmailSupport: 'Support via Email',
  PricingPagePopular: 'Most Popular',
  PricingPagePro: 'ESPER PRO',
  PricingPageProFor: 'For Large Deployments',
  PricingPageProMin1000Devices: 'Minimum 1000 Devices ',
  HomePagePricingEssentialsMin100Devics: 'Minimum 100 devices',
  PricingPageProLicense: '10 Esper User License',
  PricingPageProStorage: '50 MB Application Storage',
  PricingPageProSupport: '5 Hours Support per Month',
  PricingPageGMSAOSPSupport:
    'Support for GMS-Certified AND AOSP Devices. Google Play Apps for GMS-Certified devices only',
  PricingPageBilledAnnually: 'Billed annually',
  PricingPagePerDevicePerMonth: 'Per Device/Month',
  PricingPageTryNowCTA: 'Try it now',
  PricingPageQuoteCTA: 'Get a custom quote',
  PricingPageFeaturesAppManage: 'Application Management',
  PricingPageFeaturesAppManageApps: 'Private & Google Play Apps*',
  PricingPageFeaturesAppManageUpdate: 'Schedule App Updates',
  PricingPageFeaturesAppManageInstall: 'Easy Remote App Install',
  PricingPageFeaturesDeviceManage: 'Device Management',
  PricingPageFeaturesDeviceManageActions: 'Device Actions',
  PricingPageFeaturesDeviceManageNotifications:
    'Event Feeds & Custom Notifications',
  PricingPageFeaturesDeviceManageActivity: 'Monitor Users & Activity',
  PricingPageFeaturesDeviceGrp: 'Device Groups',
  PricingPageFeaturesDeviceGrpCommand: 'Group Commands',
  PricingPageFeaturesDeviceGrpInstall: 'Group App Install',
  PricingPageFeaturesRemote: 'Remote Diagnosis',
  PricingPageFeaturesRemoteView: 'Remote View',
  PricingPageFeaturesRemoteControl: 'Remote Control',
  PricingPageFeaturesRemoteDebug: 'Remote Debugging',
  PricingPageFeaturesDevTools: 'Developer Tools',
  PricingPageFeaturesDevToolsDevice: 'Android Virtual Device',
  PricingPageFeaturesDevToolsSDK: 'Cloud and Device SDK',
  PricingPageFeaturesDevToolsAPI: 'API Access',
  PricingPageFeaturesDevToolsConsole: ' Esper Console',
  PricingPageFeaturesDevToolsPlugin: 'Android Studio Plugin',
  PricingPageFeaturesDevops: 'Advanced DevOps Pipelines',
  PricingPageFeaturesKiosk: 'Kiosk Mode Lockdown',
  PricingPageFeaturesReports: 'Reports',
  PricingPageFeaturesGeofencing: 'Geofencing',
  PricingPagePremiumFeaturesTitle: 'Additional Premium Esper Features',
  PricingPagePremiumFeaturesDesc1:
    'So, you have huge goals for Android mobility.Luckily, you’re not alone.Esper’s services team can turn your roadmap into reality.',
  PricingPagePremiumFeaturesDesc2:
    'Esper’s Premium Features are optional add - ons to our pricing tiers.Start a conversation to learn more.',
  PricingPagePremiumFeaturesCloudHostingTitle: 'Virtual Private Cloud Hosting',
  PricingPagePremiumFeaturesCloudHostingDesc:
    'Provision private cloud resources for enhanced security, disaster - recovery, or flexibility.',
  PricingPagePremiumFeaturesEnhancedTitle:
    'Esper Enhanced Android Support for your Device',
  PricingPagePremiumFeaturesEnhancedDesc:
    'Secure, customized Android OS for remote control, OTA updates and seamless provisioning.',
  PricingPagePremiumFeaturesHardwareTitle: 'Hardware Qualification Support',
  PricingPagePremiumFeaturesSupportDesc:
    'Device validation to qualify hardware for your use case and cloud - to - cloud compatibility.',
  PricingPagePremiumFeaturesCustomAndroidTitle:
    'Custom Android Device Development',
  PricingPagePremiumFeaturesCustomAndroidDesc:
    'Speed deployment with Esper’s manufacturing consulting and OEM / ODM partnerships.',
  PricingPagePremiumFeaturesAndroidOTATitle:
    'Android OTA Support and Managed Updates',
  PricingPagePremiumFeaturesAndroidOTADesc:
    'Unlock managed, quarterly updates OTA for supported devices and custom hardware.',
  PricingPagePremiumFeaturesOnsiteOnboardingTitle:
    'Onsite Onboarding Support During your First Deployment',
  PricingPagePremiumFeaturesOnsiteOnboardingDesc:
    ' Go live with confidence and the on - site support of an Esper deployment specialist.',
  PricingPagePremiumFeaturesCloudPlatformTitle:
    'Cloud Platform and Experience Engineering',
  PricingPagePremiumFeaturesCloudPlatformDesc:
    'Speed up innovation with the support of Esper’s engineering services teams.',
  PricingPageGetQuote: 'Get a Quote',
  PricingPageCustomPricing: ' Custom pricing in 1 business day!',
  PricingPageDemo: 'Schedule a Demo',
  PricingPageTalkToRep: ' Talk to an Esper representative today!',
  PricingPageMoreThan1000Device:
    'Do you have more than 1, 000 single - purpose Android devices ?',
  PricingPageTalkToProductTeam: ' Talk to Our Product Team',
  PricingPageCustomizedDevice:
    'Are you a startup building customized Android devices ?',
  PricingPageContactUs: 'Contact us Today',
  PricingPageFAQTitle: 'Esper Pricing FAQ',
  PricingPageFAQFreeQuestion: 'Can I Use Esper Cloud for Free ?',
  PricingPageFAQFreeAns:
    'Yes, you can access the Starter edition for Free.Starter edition has support for upto 100 devices.',
  PricingPageFAQLicenseQuestion: 'How Does the License Work?',
  PricingPageFAQLicenseAns:
    'Esper offers the industry’s most simple and transparent annual pricing structure based on the number of devices.',
  PricingPageFAQTrialQuestion: 'Is Trial Data Retained?',
  PricingPageFAQTrialAns:
    'Your trial data, devices, and compliance policy templates will seamlessly transfer if you purchase Esper Essentials or Pro by the end of the 30 - day trial.',
  PricingPageFAQUpgradeQuestion: ' What if I Decide to Upgrade My Plan?',
  PricingPageFAQUpgradeAns:
    'If you purchase Esper Essentials and need to upgrade to Pro, you can access prorated annual pricing for this upgrade.',
  PricingPageFAQDeviceSupportQuestion: ' What Type of Devices are Supported?',
  PricingPageFAQDeviceSupportAns:
    'Android single - purpose devices which run Android version 4.4 KitKat or above with API Level 19. However, we recommend devices running Android version 7.0 Nougat(API Level 24) or above be used with Esper.',
  PricingPageFAQMinDeviceQuestion: 'What is the Minimum Number of Devices?',
  PricingPageFAQMinDeviceAns:
    ' Startups should start a conversation with Esper for a custom quote, however, the solution is generally best designed to support Android fleets with 100 + devices.',
  PricingPageFAQPartnerQuestion: 'Do You Have a Partnership Program?',
  PricingPageFAQPartnerAns:
    'Yes, Esper partners with device makers, ISVs and other Android solutions providers.Learn more.',
  PricingPageFAQSupportQuestion: 'Do You Offer Free Support?',
  PricingPageFAQSupportAns:
    'Yes.Esper Essentials includes direct access to engineering, a system monitoring dashboard, forums, and a knowledge base.Esper Pro includes 5 hours of engineering support monthly, ticket portal access, 24 / 7 support, a system monitoring dashboard, forums, and knowledge base.',
  PricingPageFAQCancelQuestion: ' Can I Cancel at Any Time?',
  PricingPageFAQCancelAns:
    ' Technically, yes.However, Esper is billed annually, so you will retain access for the remainder of the year.',
  PricingPageFAQTrainingQuestion: ' What Kind of Training is Offered?',
  PricingPageFAQTrainingAns:
    'Esper offers training via videoconferencing and face to face.Specific training arrangements per client request can be included as part of custom price quotes.',
  PricingPagePlatformPricingTitle: 'Talk to Esper About Platform Pricing.',
  PricingPagePlatformPricingDesc:
    " Schedule a No - Pressure Talk with Esper's Android Experts About Your Innovation Goals",
  PricingPageContactUsFormTitle: 'Connect with Esper',
  PricingPageContactUsFormName: 'Full Name',
  PricingPageContactUsFormEmail: 'Work Email',
  PricingPageContactUsFormCompany: 'Company',
  PricingPageContactUsFormContactNumber: 'Contact Number',
  PricingPageContactUsFormSubmitButton: 'Submit',

  ContactUsPageTitle1: 'Talk to Our Team',
  ContactUsPageDesc1:
    'We would love to hear from you about our product or any query you have regarding app and device management.',
  ContactUsPageTitle2: 'Office location',
  ContactUsPageTitle3: 'Contact email',
  ContactUsPageFormName: 'Full Name',
  ContactUsPageFormEmail: 'Work Email',
  ContactUsPageFormQues: 'What’s on your mind',
  ContactUsPageFormSendButton: 'Send',
  ContactUsPagePartnerInfo: 'You’re in good company, Our Partners',

  DemoPageTitle:
    'See why Esper is the world’s fastest-growing cloud tools for Android deployment and application management.',

  DemoPageDesc1:
    'Customers worldwide rely on Esper to develop, deploy, and monitor Android. Our cloud tools offer everything you need to securely scale your single-purpose hardware and apps - plus, our product is backed by our world-class customer support team.',

  DemoPageSubTitle1: `Esper's Android DevOps solution is industry-leading source
    to:`,

  DemoPageBullet1: 'Manage GSM and AOSP Android',
  DemoPageBullet2: 'Achieve Seamless, No-Touch Provisioning',
  DemoPageBullet3: 'Develop and Deploy Android Apps',
  DemoPageBullet4: 'Remotely control and View Devices',
  DemoPageBullet5: 'Update OS & Apps Over-the-Air',

  DemoPageFormTitle: 'Request A Demo',
  DemoPageFormName: 'Full Name',
  DemoPageFormEmail: 'Work Email',
  DemoPageFormCompany: 'Company',
  DemoPageFormContactNumber: 'Contact Number',
  DemoPageFormDevices: 'Number of devices',
  DemoPageFormSubmitButton: 'Next',
  DemoPageCommDesc:
    'Fill out the form to the right to request a custom demo today. Or, reach out to ',
  DemoPageCommDesc2: 'for general queries.',
  DemoPageFinePrint1: 'I agree to subscribe to Esper’s blogs',
  DemoPageFinePrint2: 'By submitting this form you agree to ',

  AboutUsPageTitle: 'Hi, We’re Esper',
  AboutUsPageDesc1:
    'We’re the world’s most powerful platform for enterprise Android device and application deployment. Esper is an end-to-end solution for Android deployment and operations, or DevOps. Esper goes way beyond MDM to create a complete toolchain for Android DevOps. We deliver operational excellence and a stable, scalable infrastructure to help you quickly deploy your experiences at scale.',
  AboutUsPageDesc2:
    'Esper’s business is about helping you take control and automate the entire Android life cycle so you can focus your team on competing where it matters most.',
  AboutUsPageStoryTitle: 'Here’s Our Story',
  AboutUsPageStoryTitle2: 'How Esper Got Started',
  AboutUsPageStoryDesc1:
    'Android has become the most popular platform for IoT devices which require a user experience. The latest generation of connected devices is all run on Android, from smart bikes to mobile point-of-sale and restaurant kiosks.',
  AboutUsPageStoryDesc2:
    'It’s crystal clear why enterprises choose Android. It’s free, open-source, comprehensive, and there’s broad support. What’s less clear, however, is how enterprises should manage this latest generation of endpoints. Most MDM solutions lack basic visibility into things that really matter, like whether a kiosk is turned on, let alone operational efficiency metrics. That’s where Esper comes in.',
  AboutUsPageStoryDesc3:
    'Esper’s Senior Leadership team has nearly 60 years of experience solving complicated enterprise device problems. We know Android inside and out.',
  AboutUsPageCTAText1:
    'Esper was purpose-built by enterprise engineers, for engineers, ',
  AboutUsPageCTAText2: 'to simplify the enterprise Android device ecosystem.',
  AboutUsPageCTAGetInTouch: 'Get in Touch',
  AboutUsPageValues: 'Our Values',
  AboutUsPageMissionTitle: ' Esper’s Mission',
  AboutUsPageMissionDesc1:
    'Smart, connected devices are woven into the fabric of your business. You need to manage these enterprise mobile devices. You also need to develop incredible customer experiences, secure your devices, and monitor your fleet. We’re shifting the conversation beyond MDM to Android DevOps. We’re powered by three core values; product, customer obsession, and operational excellence.',
  AboutUsPageMissionDesc2:
    ' Esper’s mission is honestly pretty simple. We want to empower enterprise digital transformation by providing a full stack of solutions for the Android device lifecycle.',
  AboutUsPageMissionDesc3:
    'Our customers provide the vision for digital and mobile transformation, and we provide an Android DevOps platform. Our toolchain includes everything you need for a complete customer experience pipeline.',
  AboutUsPageLeadershipTitle: 'Our Leadership & People',
  AboutUsPageLeadershipCEO: 'Co-Founder & CEO',
  AboutUsPageLeadershipCEODesc:
    'Yadhu has over 25 years and 35 patents in embedded systems and security. His 25-year career included roles as Chief Architect of the Windows CE and Windows Phone. At Amazon, Yadhu designed back-end solutions for the FireOS, and AWS before he owned Systems Engineering for Amazon Go. Today, Yadhu is our Chief Geek, CEO, and Co-Founder, and the visionary behind our mission to educate enterprises about DevOps for Smart Edge devices.',
  AboutUsPageLeadershipCOO: 'Co-Founder & COO',
  AboutUsPageLeadershipCOODesc:
    'Shiv makes things happen, both at Esper and for our customers. He knows Android inside-and-out after running Android partnerships for Huawei. Shiv strengthened his open source and device maker relationships after managing OEM partnerships at Cyanogen and Windows Phone device commercialization for Microsoft. Shiv is always ready to help businesses achieve Secure DevOps and deliver incredible customer experiences.',
  AboutUsPageLeadershipVPMarketing: 'VP - Developer Marketing',
  AboutUsPageLeadershipVPMarketingDesc:
    ' Keith is the geeky force-of-nature that drives Esper’s efforts to build a community of Android dedicated device developers and creators. He evangelizes Esper’s value to devs, Product Owners, and Chief Tech officers. Keith’s experience includes running product management for a dev tools startup that was sold to Symantec. Next, he worked at Microsoft with MSDN, CryptoAPI, Windows CE / Platform Builder, and Windows Mobile. Keith’s first programming language was BASIC on the TRS-80. He’s also shipped code for a PDP -11 at Siemens.',
  AboutUsPageLeadershipVPCustomerSuccess: 'VP - Customer Success',
  AboutUsPageLeadershipVPCustomerSuccessDesc:
    'Chris helps our customers gain an agile advantage with Android DevOps across industries and use cases. Previously, he coached product, development, and innovation teams in executive roles at Microsoft, BNY Mellon, Eagle Investment Systems, and Caradigm. Chris has 25+ years’ experience as a champion and leader for the entire technical product and service lifecycle.',
  AboutUsPageInvestors: 'Our Investors',
  AboutUsPageDeepBench: 'Esper’s Deep Bench ',

  SignupPageTitle:
    // 'Sign Up for Esper, the Industry’s Most Powerful Platform for Android Device Deployment and Application Management.',
    'The Industry’s Leading App and Device Management Platform For Android Devices',
  SignupPagePoint1: '60% Operational cost savings compared to traditional MDM',
  SignupPagePoint2: 'Support for GMS and AOSP',
  SignupPagePoint3: 'Compatible with Android OS Versions 4.5, 5.x+',
  SignupPagePoint4: 'Streamlined Secure Provisioning and Deployment',
  SignupPagePoint5: 'Custom Alerts and Real-Time Activity Reports',
  SignupPagePoint6: 'Remote Monitoring and Debugging',
  SignupPagePoint7: 'Automated Real-Time Risk Response',
  SignupPageFormTitle: 'Get Started For Free',
  SignupPageFormNoCreditCard: 'No credit card required',
  SignupPageFormEmail: 'Work Email',
  SignupPageFormName: 'Full Name',
  SignupPageFormCompany: 'Company Name',
  SignupPageFormNumber: 'Contact Number',
  SignupPageFormCTA: 'Get Started For Free',
  SignupPageUnableToSignup1: 'Unable to Sign up ?',
  SignupPageUnableToSignup2: 'Contact Us',
  SignupPageHaveAnAccount1: 'Have an account?',
  SignupPageHaveAnAccount2: ' Sign in',
  SignupPageStarterPackTitle: 'Forever FREE Up to 100 Android Devices',
  WebsiteGeneralCopyright1: 'Copyright',
  WebsiteGeneralCopyright2: 'Esper - All Rights Reserved',
  WebsiteGeneralFooterText:
    'Esper empowers Engineers, Developers, and Operations teams with tools crafted for company owned Android devices. Our full stack platform covers building, deploying, managing, and maintaining to move beyond MDM and to Android DevOps.	',
  WebsiteGeneralLoginCTA: 'Login	',
  WebsiteGeneralSignupCTA: 'Sign up',
  WebsiteGeneralMenuPricing: 'Pricing',
  WebsiteGeneralMenuAboutUs: 'About us	',
  WebsiteGeneralMenuContactUs: 'Contact us	',
  WebsiteGeneralFooterFAQ: 'FAQ	',
  WebsiteGeneralFooterBookDemo: 'Book Demo',
  WebsiteGeneralFooterBookAFreeDemo: 'Book a Free Demo',
  WebsiteGeneralFooterPrivacyPolicy: 'Privacy Policy',
  WebsiteGeneralMenuTermsOfService: 'Terms of Service',
  WebsiteGeneralFooterSitemap: 'Sitemap',
  WebsiteGeneralFooterGetInTouch: 'Get in Touch',
  WebsiteGeneralFooterBlog: 'Blog',
  WebsiteGeneralFooterDocs: 'Documentation',
  WebsiteGeneralMenuWhyEsper: 'Why Esper?',
  WebsiteGeneralMenuCompany: 'Company',
  WebsiteGeneralMenuResources: 'Resources',
  WebsiteGeneralFooterExplore: 'Explore',
  WebsiteGeneralFooterContact: 'Contact',
  WebsiteConsentText1: 'I agree to subscribe to Esper’s blogs',
  WebsiteConsentText2: 'By submitting this form you agree to ',
  WebsiteConsentText3: 'our terms ',
  WebsiteConsentText4: '& privacy policy',
  WebsiteConsentErrorValidationText: 'Please complete the required field',

  AllFormValidationMessagesName: 'Please enter your name',
  AllFormValidationMessagesEmail: 'Please enter an email address',
  AllFormValidationMessagesValidEmail: 'Please enter a valid email address',
  AllFormValidationMessagesCompany: 'Please enter your company name',
  AllFormValidationMessagesPhoneNumber: 'Please enter your contact number',
  AllFormValidationMessagesValidCompanyName:
    'Please enter a valid company name',
  AllFormValidationMessagesValidName: 'Please enter a valid name',
  AllFormValidationMessagesValidPhoneNumber:
    'Please enter a valid contact number',
  validCountryErrorMessage: 'Please select your country',
  AllFormValidationMessagesAccountExists:
    'Sorry, an account was already created with this Email address',
  AllFormValidationMessagesWorkEmail: 'Please enter your work email',
  AllFormValidationMessagesReq: 'Please enter your requirements',

  FAQPageCTAText: 'Find Out Why Esper Is Right For Your Business',
  FAQPageCTAButton: 'Schedule a demo',
  FAQPageTitle: 'How can we help you ?',
  FAQPageLoadMoreButton: 'Load more',
  FAQSearch: 'Search Topics',
  FAQNoResult: 'Sorry no results found',

  LoginPageTitle: 'LOGIN TO YOUR ESPER ACCOUNT',
  LoginPageDecsription:
    "Enter your unique endpoint name below and we'll take you to your account. You can then login with your Esper credentials.",
  LoginPageEndPointName: 'Endpoint Name',
  LoginPageForgotPortalURL: 'Forgot Your Portal URL?',
  LoginPageDontAccount: 'Don’t Have An Account?',
  LoginPageSignupForFree: 'Sign up for free',
  LoginPageEndPointNameValidationMessage: 'Please enter a valid endpoint name',
};
